function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function architecture() {
  return import(
    /* webpackChunkName: "page-architecture" */ '@/pages/architecture.vue'
  )
}
function contacts() {
  return import(/* webpackChunkName: "page-contacts" */ '@/pages/contacts.vue')
}
function cookies() {
  return import(/* webpackChunkName: "page-cookies" */ '@/pages/cookies.vue')
}
function design() {
  return import(/* webpackChunkName: "page-design" */ '@/pages/design.vue')
}
function developer() {
  return import(
    /* webpackChunkName: "page-developer" */ '@/pages/developer.vue'
  )
}
function documentation() {
  return import(
    /* webpackChunkName: "page-documentation" */ '@/pages/documentation.vue'
  )
}
function improvement() {
  return import(
    /* webpackChunkName: "page-improvement" */ '@/pages/improvement.vue'
  )
}
function location() {
  return import(/* webpackChunkName: "page-location" */ '@/pages/location.vue')
}
function parking() {
  return import(/* webpackChunkName: "page-parking" */ '@/pages/parking.vue')
}
function privacy() {
  return import(/* webpackChunkName: "page-privacy" */ '@/pages/privacy.vue')
}
function process() {
  return import(/* webpackChunkName: "page-process" */ '@/pages/process.vue')
}
function flats_index() {
  return import(
    /* webpackChunkName: "page-flats-index" */ '@/pages/flats/index.vue'
  )
}
function flats_flat__id() {
  return import(
    /* webpackChunkName: "page-flats-flat-id" */ '@/pages/flats/flat/_id.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: index,
  },
  {
    name: 'architecture',
    path: 'architecture',
    component: architecture,
  },
  {
    name: 'contacts',
    path: 'contacts',
    component: contacts,
  },
  {
    name: 'cookies',
    path: 'cookies',
    component: cookies,
  },
  {
    name: 'design',
    path: 'design',
    component: design,
  },
  {
    name: 'developer',
    path: 'developer',
    component: developer,
  },
  {
    name: 'documentation',
    path: 'documentation',
    component: documentation,
  },
  {
    name: 'improvement',
    path: 'improvement',
    component: improvement,
  },
  {
    name: 'location',
    path: 'location',
    component: location,
  },
  {
    name: 'parking',
    path: 'parking',
    component: parking,
  },
  {
    name: 'privacy',
    path: 'privacy',
    component: privacy,
  },
  {
    name: 'process',
    path: 'process',
    component: process,
  },
  {
    name: 'flats',
    path: 'flats',
    component: flats_index,
  },
  {
    name: 'flats-flat-id',
    path: 'flats/flat/:id?',
    component: flats_flat__id,
  },
]
